export default __webpack_public_path__ + "static/media/register-account-bee.f31319d6.png";